import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardImg,
    CardBody,
    CardTitle,
    Button,
    Modal,
    ModalBody,
} from "reactstrap";
import Axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import GalerryPageHeader from "../../components/Headers/GalerryPageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";

const GalerryPage = () => {
    const [dataGaleri, setDataGaleri] = useState([]);
    const [dataGroupGaleri, setDataGroupGaleri] = useState([]);
    const [activeCategory, setActiveCategory] = useState("ALL");
    const [modal, setModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        document.body.classList.add("Galerry-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);

        AOS.init({ duration: 1000, easing: "ease-in-out" });

        return () => {
            document.body.classList.remove("Galerry-page", "sidebar-collapse");
        };
    }, []);

    useEffect(() => {
        const getDataGaleri = async () => {
            try {
                const response = await Axios.get(`${process.env.REACT_APP_API_URL}/galery/readGaleri`);
                setDataGaleri(response.data);
            } catch (error) {
                console.error("Error fetching gallery data:", error);
            }
        };

        const getDataGroupGaleri = async () => {
            try {
                const response = await Axios.get(`${process.env.REACT_APP_API_URL}/galeryGroup/readGaleriGroup`);
                setDataGroupGaleri(response.data);
            } catch (error) {
                console.error("Error fetching gallery group data:", error);
            }
        };

        getDataGaleri();
        getDataGroupGaleri();
    }, []);

    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "2-digit" };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const GalerryHeader = ({ activeCategory, setActiveCategory }) => (
        <div className="galerry-header-main" style={{ textAlign: "center", margin: "20px 0" }}>
            <Row className="justify-content-center">
                <Col xs="auto">
                    <Button
                        color="primary"
                        className={`category-button ${activeCategory === "ALL" ? "active" : ""}`}
                        onClick={() => setActiveCategory("ALL")}
                        style={{
                            borderRadius: "32px",
                            padding: "10px 20px",
                            margin: "0 8px",
                            backgroundColor: activeCategory === "ALL" ? "#007bff" : "#84DEFF",
                            color: activeCategory === "ALL" ? "white" : "#FFFFFF",
                            border: "none",
                        }}
                    >
                        <b>
                            <i>Semua</i>
                        </b>
                    </Button>
                    {dataGroupGaleri.map((category, index) => (
                        <Button
                            key={index}
                            color="primary"
                            className={`category-button ${
                                category.group_galeri === activeCategory ? "active" : ""
                            }`}
                            onClick={() => setActiveCategory(category.group_galeri)}
                            style={{
                                borderRadius: "32px",
                                padding: "10px 20px",
                                margin: "0 8px",
                                backgroundColor:
                                    category.group_galeri === activeCategory
                                        ? "#007bff"
                                        : "#84DEFF",
                                color: activeCategory === "ALL" ? "white" : "#FFFFFF",
                                border: "none",
                            }}
                        >
                            <b>
                                <i>{category.group_galeri}</i>
                            </b>
                        </Button>
                    ))}
                </Col>
            </Row>
        </div>
    );

    const mergeImages = (galeriData) => {
        let allImages = [];
        galeriData.forEach((item) => {
            const {
                foto_satu,
                foto_dua,
                foto_tiga,
                title_foto_satu,
                title_foto_dua,
                title_foto_tiga,
                tanggal,
                group_galeri,
            } = item;

            if (foto_satu) {
                allImages.push({ src: foto_satu, title: title_foto_satu, tanggal, group_galeri });
            }
            if (foto_dua) {
                allImages.push({ src: foto_dua, title: title_foto_dua, tanggal, group_galeri });
            }
            if (foto_tiga) {
                allImages.push({ src: foto_tiga, title: title_foto_tiga, tanggal, group_galeri });
            }
        });

        return allImages.sort((a, b) => new Date(b.tanggal) - new Date(a.tanggal));
    };

    const filteredPosts =
        activeCategory === "ALL"
            ? mergeImages(dataGaleri)
            : mergeImages(dataGaleri).filter((image) => image.group_galeri === activeCategory);

    const toggleModal = (image) => {
        setSelectedImage(image);
        setModal(!modal);
    };

    return (
        <>
            <ExamplesNavbar />
            <div className="wrapper">
                <GalerryPageHeader />
                <div className="section">
                    <Container>
                        <GalerryHeader
                            activeCategory={activeCategory}
                            setActiveCategory={setActiveCategory}
                        />
                        <Row>
                            {filteredPosts.length === 0 ? (
                                <p className="text-center">No images available in this category.</p>
                            ) : (
                                filteredPosts.map((post, index) => (
                                    <Col
                                        sm="12"
                                        md="6"
                                        lg="4"
                                        key={index}
                                        className="mb-4"
                                        data-aos="fade-up"
                                    >
                                        <div
                                            onClick={() => toggleModal(post.src)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <img
                                                src={post.src}
                                                alt={`gallery-${index}`}
                                                style={{ width: "100%", borderRadius: "8px" }}
                                            />
                                            <div style={{ marginTop: "8px" }}>
                                                <h5>{post.title}</h5>
                                                <p>{formatDate(post.tanggal)}</p>
                                            </div>
                                        </div>
                                    </Col>
                                ))
                            )}
                        </Row>
                    </Container>
                </div>
                <DefaultFooter />
            </div>
            <Modal isOpen={modal} toggle={() => toggleModal(null)}>
                <ModalBody>
                    <img src={selectedImage} alt="Selected" style={{ width: "100%" }} />
                </ModalBody>
            </Modal>
        </>
    );
};

export default GalerryPage;
